// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"0e101e14","329":"143a9542","446":"42b61765","630":"b9b28783","828":"4ec4f00f"}[chunkId] + ".chunk.css";
};